import React, { useState } from 'react';

import {
    Button,
    DialogContent,
    DialogActions,
    Grid,
    TextField,
    Switch,
    Select,
    MenuItem
} from '@material-ui/core';
import InputMask from "react-input-mask";
import { toast } from 'react-toastify';

import Label from '../../../../components/Label';
import { categoryEnum } from '../../../../config/category';
import { gradeEnum } from '../../../../config/grade';

import EventApi from '../../../../services/event';

import {
    Align,
} from './styles';

const CreatePerson = (props) => {
    const [person, setPerson] = useState({
        id: 0,
        name: "",
        email: "",
        cpf: "",
        phone: "",
        rfid: "",
        role: "",
        certificate: 0,
        enable: true,
        vip: false,
        status_id: 1,
        position_id: 0,
        category_id: 0,
        category: '',
        grade_id: 0,
        grade: '',
        is_guest: true,
    });

    const categoryValues = props.categoryValues;
    const categoryNames = props.categoryNames;
    const gradeValues = props.gradeValues;
    const gradeNames = props.gradeNames;

    function onChange(event) {
        const { value, name } = event.target;
        setPerson({ ...person, [name]: value });
    }

    const handleChange = (event) => {
        const { checked, name } = event.target;
        setPerson({ ...person, [name]: checked });
    };

    const handleSelect = (event, valuesList, keyName1, keyName2) => {
        const { value } = event.target;
        Object.keys(valuesList).forEach((key) => {
            if (valuesList[key].name === value) {
                setPerson({
                    ...person,
                    [keyName1]: parseInt(key, 10),
                    [keyName2]: value,
                })
            }
        })
    };

    const newPerson = () => {
        EventApi.createPerson({
            ...person,
            cpf: person.cpf?person.cpf.match(/\d/g).join(""):null,
            phone: person.phone?person.phone.match(/\d/g).join(""):null,
            position_id: props.selected.id,
            event_id: props.eventData.id,
        })
        .then(resp => {
            if (!!resp.data) {
                toast.success('usuário criado com sucesso!')
            }
            props.handleClose();
        })
        .catch(function(error) {
            toast.error(error)
            props.handleClose();
        });
    }

    return (
        <>
        <DialogContent>
        <Grid container justify="space-around" spacing={2}>
            <Grid item md={6}>
                <TextField
                    key="nome"
                    name="name"
                    required
                    label="Nome do convidado"
                    onChange={onChange}
                    value={person.name}
                    fullWidth
                />
            </Grid>
            <Grid item md={6}>
                <TextField
                    key="email"
                    name="email"
                    label="Email para contato"
                    onChange={onChange}
                    value={person.email}
                    fullWidth
                />
            </Grid>
        </Grid>
        <Grid container justify="space-around" spacing={2}>
            <Grid item md={5}>
                <InputMask
                    mask="999.999.999-99"
                    value={person.cpf}
                    onChange={onChange}
                    disabled={false}
                    maskChar=""
                    type="text"
                    name="cpf"
                >
                    {() => <TextField
                        key="cpf"
                        name="cpf"
                        label="CPF"
                        fullWidth
                        value={person.cpf}
                        onChange={onChange}
                    />}
                </InputMask>
            </Grid>
            <Grid item md={5}>
                <InputMask
                    mask="+55 (99) 9 9999-9999"
                    value={person.phone}
                    onChange={onChange}
                    disabled={false}
                    maskChar=""
                    type="text"
                    name="phone"
                >
                    {() => <TextField
                        key="phone"
                        name="phone"
                        label="Telefone para contato"
                        fullWidth
                        value={person.phone}
                        onChange={onChange}
                    />}
                </InputMask>
            </Grid>
            <Grid item md={2}>
                <Align>
                    <Switch
                        checked={person.vip}
                        onChange={handleChange}
                        name="vip"
                    />
                    <Label>
                        VIP
                    </Label>
                </Align>
            </Grid>
        </Grid>
        <Grid container justify="space-around" spacing={2}>
            <Grid item md={6}>
                <TextField
                    key="role"
                    name="role"
                    label="Cargo"
                    onChange={onChange}
                    value={person.role}
                    fullWidth
                />
            </Grid>
            <Grid item md={6}>
                <TextField
                    key="rfid"
                    name="rfid"
                    label="Tag ID"
                    onChange={onChange}
                    value={person.rfid}
                    fullWidth
                />
            </Grid>
        </Grid>
        <Grid container justify="center" spacing={2}>
            <Grid 
                container
                justifyContent="space-around"
                direction="column"
                md={10}
                alignItems="stretch"
            >
                <Label>Categoria: </Label>
                <Select
                    placeholder="Categoria"
                    label="Categoria"
                    name="category"
                    fullWidth
                    value={person.category}
                    onChange={(e) => handleSelect(e, categoryValues, 'category_id', 'category')}
                >
                    {categoryNames.map(item => { return (
                        <MenuItem value={item}>{categoryEnum[item]}</MenuItem>
                    )})}
                </Select>
            </Grid>
            <Grid 
                container
                justifyContent="space-around"
                direction="column"
                md={10}
                alignItems="stretch"
            >
                <Label>Grau: </Label>
                <Select
                    placeholder="Grau"
                    label="Grau"
                    name="grade"
                    fullWidth
                    value={person.grade}
                    onChange={(e) => handleSelect(e, gradeValues, 'grade_id', 'grade')}
                >
                    {gradeNames.map(item => { return (
                        <MenuItem value={item}>{gradeEnum[item]}</MenuItem>
                    )})}
                </Select>
            </Grid>
        </Grid>
        </DialogContent>
         <DialogActions>
            <Button onClick={props.handleClose} color="primary">
                cancelar
            </Button>
            <Button
                onClick={() => { newPerson() }}
            >
                criar convidado
            </Button>
        </DialogActions>
        </>
    )
}

export default CreatePerson;
